<template>
    <div class="new-product-card" :class="variant">
        <div class="card-img-top">
            <div class="status-badges"
                v-if="(info.especial && info.especial !== 'False' && info.especial !== 'false') || info.badgenuevo || info.mejoresventaslineas || info.mejoresventas">
                <BadgesProducto :item="info" />
            </div>

            <img v-if="info.PicturesUrl && info.PicturesUrl[info.categorias?.[0]?.marcas?.viewimagesprinc ?? 4]"
                :src="info.PicturesUrl[info.categorias[0].marcas.viewimagesprinc ?? 4].sm" class="img-fluid"
                :alt="info.linea + ' ' + info.k_parte" loading="lazy" draggable="false" />


            <img v-else src="/img/display/Placeholder.png" class="img-fluid" :alt="info.linea + ' ' + info.k_parte" />

            <!--<div class="compatibility-badge" v-if="info.marcas_resumen">
                <i class="bx bxs-check-circle"></i>
                Compatible con tu vehículo
            </div>-->
            <span v-if="vehiculoSeleccionado?.marca && info.marcas_resumen?.includes(vehiculoSeleccionado.marca)"
                class="compatibility-badge">
                <i class="fas fa-check-circle"></i> Compatible con tu {{ vehiculoSeleccionado.marca }}
            </span>
        </div>

        <div class="card-info-bottom">
            <p class="category-text mb-1">
                {{ info.linea }}
            </p>

            <p class="car-application">
                {{ aplicacionTexto }}
            </p>

            <!-- k_parte como link -->
            <div class="price-tag clickable-code" @click="goToDetail">
                <span class="currency">Código</span>
                <span class="amount">{{ info.k_parte }}</span>
            </div>

            <!-- botón detalles -->
            <button class="btn-view-details mt-2" @click="goToDetail">
                Ver detalles <i class="bx bx-chevron-right"></i>
            </button>
        </div>
    </div>
</template>
<script>
import BadgesProducto from '../../../Sales/DDP/visual_assets/Badges.vue';
export default {
    name: "Cardsprodspresentation",

    props: {
        info: {
            type: Object,
            required: true,
            default: () => ({})
        },
        variant: {
            type: String,
            default: "default" // default | inverse
        }
    },
    components: {
        BadgesProducto
    },
    methods: {
        goToDetail() {
            this.$router.push({
                name: 'detalleProducto',
                query: {
                    codigo: this.info.k_parte
                }
            });
        }
    },
    computed: {
        vehiculoSeleccionado() {
            return this.$store.getters.vehiculoSeleccionado;
        },
        /*aplicacionTexto() {
            let app = null;

            // Caso 1: viene como array
            if (Array.isArray(this.info?.aplicaciones) && this.info.aplicaciones.length) {
                app = this.info.aplicaciones[0];
            }
            // Caso 2: viene como objeto plano
            else if (this.info && typeof this.info === 'object') {
                app = this.info;
            }

            if (!app) return '';

            return [
                app.marca,
                app.modelo,
                app.year,
                app.litros,
                app.cilindros,
            ]
                .map(v => typeof v === 'string' ? v.trim() : v)
                .filter(v => v && !['-', '–', 'N/A'].includes(v))
                .join(' ');
        }*/
        aplicacionTexto() {
            let app = null;

            // 1. Prioridad al nuevo campo de resumen que creamos
            if (Array.isArray(this.info?.aplicaciones_resumen) && this.info.aplicaciones_resumen.length > 0) {
                app = this.info.aplicaciones_resumen[0];
            }
            if (!app) return '';

            // Lógica para formatear el año: "2020-2020" -> "(20-20)"
            let yearFormateado = '';
            if (app.year) {
                // Separamos por el guion, quitamos los primeros dos dígitos y volvemos a unir
                yearFormateado = `(${app.year.split('-').map(y => y.toString().slice(-2)).join('-')})`;
            }

            return [
                app.marca,
                app.modelo,
                yearFormateado, // Usamos el año ya procesado
            ]
                .map(v => typeof v === 'string' ? v.trim() : v)
                .filter(v => v && !['-', '–', 'N/A', '()'].includes(v))
                .join(' ');
        }
    }
};
</script>

<style scoped>
@import '../../../../../../css/components/DetallesProducto/cardpresentation.css';
</style>